import { NgModule } from "@angular/core";
import { ConfigurationComponent } from './components/configuration/configuration.component';
import { ConfigurationsRoutingModule } from './configurations.routes';
import { InitialsPipe } from './pipes/initials.pipe';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { AccountsService } from './services/accounts.service';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../common/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { UsersService } from "./services/users.service";
import { MatLegacySnackBarModule as MatSnackBarModule } from "@angular/material/legacy-snack-bar";
import { OAuthModule } from "angular-oauth2-oidc";

@NgModule({
    declarations: [
        ConfigurationComponent,
        InitialsPipe
    ],
    imports: [
        CommonModule,
        ConfigurationsRoutingModule,
        MatButtonModule,
        MatInputModule,
        CoreModule,
        MatSelectModule,
        TranslateModule,
        MatSnackBarModule,
        OAuthModule
    ],
    exports: [
        ConfigurationComponent
    ],
    providers: [
        AccountsService,
        UsersService
    ]
})
export class ConfigurationsModule { }